import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import MediaHorasExtrasMOTCStore from "../stores/MediaHorasExtrasMOTCStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'CARGO', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM', 'PRODUTO', 'AR_DEBITO'];

@inject("store")
@DataWrapper
@observer
export class MediaHorasExtrasMOTC extends Component {
    constructor(props) {
        super(props);
        this.controller = new MediaHorasExtrasMOTCStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Média de horas extras da MOT por Unidade de negócio (BU)");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart dataKeys={["Média (h)"]} data={this.controller.dados} legend={false}
                                        labelAxisX={"Unidade de negócio (BU)"} labelAxisY={"Média (h)"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
